import React, { useState, useEffect } from "react";
import { Select, Form } from "antd";
import { SITE_URL } from "../../../../utilities/constants";
import axios from "axios";

const { Option } = Select;
const CountryStateSelector = ({ handleCountySelector }) => {
  const [data, setData] = useState({ countries: [], statesByCountry: {} });
  const [selectedCountry, setSelectedCountry] = useState(null);

  const fetchCountries = async () => {
    try {
      const response = await axios.get(`${SITE_URL}countries_b.json`);
      if (response.data) {
        const countries = response.data;
        const statesByCountry = {};
        countries.forEach((country) => {
          statesByCountry[country.name] = country.states || [];
        });
        setData({ countries, statesByCountry });
      }
    } catch (error) {
      console.error("🚀 ~ fetchCountries ~ error:", error);
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  const handleCountryChange = (name) => {
      setSelectedCountry(name);
      localStorage.setItem("setSelectedCountry", name);
    if (name) {
      // Reset the state field when the country changes
      form.setFieldsValue({ state: null });
    }
  };

  const handleSubmit = (values) => {
    handleCountySelector(values);
  };

  const [form] = Form.useForm();

  return (
    <Form
      onFinish={handleSubmit}
      className="ps-form--account ps-form--account-register"
      form={form}
    >
      <div className="form-group">
        <Form.Item
          name="country"
          rules={[{ required: true, message: "Please select a country." }]}
        >
          <Select
            placeholder="Select a country"
            onChange={handleCountryChange}
            allowClear
            showSearch
            optionFilterProp="children"
          >
            {data.countries.map((country) => (
              <Option key={country.name} value={country.name}>
                {country.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </div>
      <div className="form-group">
        <Form.Item
          name="state"
          rules={[{ required: true, message: "Please select a state." }]}
        >
          <Select
            placeholder="Select a state"
            disabled={!selectedCountry}
            allowClear
            showSearch
            optionFilterProp="children"
          >
            {(data.statesByCountry[selectedCountry] || []).map((state) => (
              <Option key={state.name} value={state.name}>
                {state.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </div>
      <div className="form-group submit">
        <Form.Item>
          <button type="submit" className="ps-btn ps-btn--fullwidth">
            Continue
          </button>
        </Form.Item>
      </div>
    </Form>
  );
};

export default CountryStateSelector;
